import { MESES } from "../constants/months";
import { P, FF } from "../styles/tokens";
import { Card } from "../components/ui";
import { EditSection, AudioRecorder, TransferenciaSection, PagarTDCSection } from "../components/inputs";
import {
  AnalisisView, ComparativaView, ProyeccionView,
  AhorroEditSection, MsiSection, ConfigView,
} from "../components/views";
import MetasView from "../components/views/MetasView";
import AnualView from "../components/views/AnualView";
import MovimientosView from "../components/views/MovimientosView";
import ResumenMes from "../components/views/ResumenMes";
import { useNavigation } from "../contexts/NavigationContext";
import { useFinancial } from "../contexts/FinancialContext";
import { useUI } from "../contexts/UIContext";
import { useLimits } from "../hooks/useLimits";
import { api } from "../services/api";
import LegalView from "../components/views/LegalView";

export default function ContentRouter() {
  const { view, section } = useNavigation();
  const {
    data, month, setMonth, saveItem, metas, setMetas, presupuestos, setPresupuestos,
    recurrentes, setRecurrentes, msiCompras, setMsiCompras, toggleMsiPago,
    cuentas, createCuenta, updateCuenta, deleteCuenta,
    categorias, createCategoria, updateCategoria, deleteCategoria,
    transferencias, setTransferencias, deudaTDC, saldoEfectivo, saldoDebito,
    capitalDisponible, comprometido,
    ahorradoPorMeta, flujo, totalIng, totalFij, totalExt, ahorroReal,
    computedSaldos, year, refetchGlobal, refetchTransferencias, diaCobro, setDiaCobro,
  } = useFinancial();
  const { activeMonth } = useNavigation();
  const { mobile, audioOpen, setAudioOpen } = useUI();
  const { hasFeature } = useLimits();

  if (view === "terminos") return <LegalView type="terminos" />;
  if (view === "privacidad") return <LegalView type="privacidad" />;
  if (view === "anual") return <AnualView />;
  if (view === "metas") return <MetasView metas={metas} setMetas={setMetas} ahorradoPorMeta={ahorradoPorMeta} data={data} flujo={flujo} mobile={mobile} totalIng={totalIng} />;
  if (view === "config") return <ConfigView cuentas={cuentas} createCuenta={createCuenta} updateCuenta={updateCuenta} deleteCuenta={deleteCuenta} categorias={categorias} createCategoria={createCategoria} updateCategoria={updateCategoria} deleteCategoria={deleteCategoria} presupuestos={presupuestos} setPresupuestos={setPresupuestos} recurrentes={recurrentes} setRecurrentes={setRecurrentes} data={data} activeMonth={activeMonth} diaCobro={diaCobro} setDiaCobro={setDiaCobro} computedSaldos={computedSaldos} refetchTransferencias={refetchTransferencias} mobile={mobile} />;
  if (section === "movimientos") return <MovimientosView />;
  if (section === "resumen") return <ResumenMes />;
  if (section === "analisis") return <AnalisisView />;
  if (section === "editar") return (
    <div>
      <Card style={{ marginBottom:16, padding:"12px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <p style={{ fontSize:13, color:P.textSm, fontFamily:FF, margin:0 }}>
          Editando <strong style={{ fontWeight:800, color:P.text }}>{MESES[activeMonth]} {year}</strong>
        </p>
        <button onClick={()=>setAudioOpen(true)}
          style={{ display:"flex", alignItems:"center", gap:6, padding:"8px 14px", borderRadius:12,
            border:"none", background:"linear-gradient(145deg, #EF4444, #DC2626)", color:"#fff",
            cursor:"pointer", fontFamily:FF, fontSize:12, fontWeight:700,
            boxShadow:"0 3px 12px rgba(239,68,68,0.25)" }}>
          <span style={{ fontSize:15 }}>🎙️</span> Dictar por voz
        </button>
      </Card>
      <EditSection title="Ingresos"      icon="💵" token={P.ingresos} rows={month.ingresos} field="ingresos" setMonth={setMonth} onSaveItem={(item) => saveItem("ingresos", item)} cuentas={cuentas} activeMonth={activeMonth} year={year} />
      <EditSection title="Gastos Fijos"  icon="🏠" token={P.fijos}    rows={month.fijos}    field="fijos"    setMonth={setMonth} onSaveItem={(item) => saveItem("fijos", item)}    isFijos cuentas={cuentas} computedSaldos={computedSaldos} activeMonth={activeMonth} year={year} />
      <EditSection title="Gastos Extras" icon="🛍️" token={P.extras}   rows={month.extras}   field="extras"   setMonth={setMonth} onSaveItem={(item) => saveItem("extras", item)}   showCat cuentas={cuentas} activeMonth={activeMonth} year={year} />
      <PagarTDCSection deudaTDC={deudaTDC} cuentas={cuentas} saldoEfectivo={saldoEfectivo} saldoDebito={saldoDebito} setTransferencias={setTransferencias} computedSaldos={computedSaldos} />
      <TransferenciaSection cuentas={cuentas} transferencias={transferencias} setTransferencias={setTransferencias} computedSaldos={computedSaldos} />
      <MsiSection msiCompras={msiCompras} setMsiCompras={setMsiCompras} toggleMsiPago={toggleMsiPago} activeMonth={activeMonth} mobile={mobile} cuentas={cuentas} />
      <AhorroEditSection month={month} setMonth={setMonth} metas={metas} data={data} activeMonth={activeMonth} cuentas={cuentas} capitalDisponible={capitalDisponible} comprometido={comprometido} setTransferencias={setTransferencias} />
    </div>
  );
  // Features exclusivas de Pro (comparativa_meses / proyeccion en PLAN_LIMITS).
  if (section === "comparativa") {
    return hasFeature("comparativa_meses")
      ? <ComparativaView data={data} activeMonth={activeMonth} mobile={mobile} />
      : <FeatureBloqueada nombre="Comparativa entre meses" />;
  }
  if (section === "proyeccion") {
    return hasFeature("proyeccion")
      ? <ProyeccionView data={data} activeMonth={activeMonth} metas={metas} ahorradoPorMeta={ahorradoPorMeta} mobile={mobile} />
      : <FeatureBloqueada nombre="Proyección" />;
  }
  return null;
}

function FeatureBloqueada({ nombre }) {
  const { navigateTo } = useNavigation();
  return (
    <Card style={{ textAlign: "center", padding: "32px 24px" }}>
      <div style={{ fontSize: 32, marginBottom: 10 }}>🔒</div>
      <h3 style={{ fontSize: 16, fontWeight: 800, color: P.text, fontFamily: FF, margin: "0 0 6px" }}>
        {nombre} es del plan Pro
      </h3>
      <p style={{ fontSize: 13, color: P.textSm, fontFamily: FF, margin: "0 0 18px" }}>
        Mejora tu plan para desbloquearla.
      </p>
      <button
        type="button"
        onClick={() => navigateTo("config")}
        style={{ padding: "10px 20px", borderRadius: 12, border: "none", background: P.ingresos.base,
                 color: "#fff", fontFamily: FF, fontSize: 13, fontWeight: 700, cursor: "pointer" }}
      >
        Ver planes
      </button>
    </Card>
  );
}
